import { $themeBreakpoints } from '@themeConfig'

export default {
  namespaced: true,
  state: {
    windowWidth: 0,
    shallShowOverlay: false,
    distributionActiveTab: 0,
    projectNavbarKey: 0,
    key: 0,
    changingProject: false,
    projectId: null,
    organizationId: null,
    projectPage: 0,
    projectName: null,
    loggingOut: false,
    errorCode: null,
    previousRouteName: '',
    namespace: null,
    updatingOrganizationId: false,
    editorLightTheme: null,
    setDefaultUser: true,
  },
  getters: {
    currentBreakPoint: state => {
      const { windowWidth } = state
      if (windowWidth >= $themeBreakpoints.xl) return 'xl'
      if (windowWidth >= $themeBreakpoints.lg) return 'lg'
      if (windowWidth >= $themeBreakpoints.md) return 'md'
      if (windowWidth >= $themeBreakpoints.sm) return 'sm'
      return 'xs'
    },
    changingProject: state => state.changingProject,
    projectId: state => state.projectId,
    organizationId: state => state.organizationId,
    previousRouteName: state => state.previousRouteName,
  },
  mutations: {
    UPDATE_WINDOW_WIDTH(state, val) {
      state.windowWidth = val
    },
    TOGGLE_OVERLAY(state, val) {
      state.shallShowOverlay = val !== undefined ? val : !state.shallShowOverlay
    },
    UPDATE_DISTRIBUTION_ACTIVE_TAB(state, id) {
      state.distributionActiveTab = id
    },
    UPDATE_KEY(state) {
      state.key += 1
    },
    UPDATE_PROJECT_KEY(state) {
      state.projectNavbarKey += 1
    },
    SET_PROJECT_ID(state, id) {
      state.projectId = id !== null ? id.toLowerCase() : id
    },
    SET_PROJECT_NAME(state, name) {
      state.projectName = name
    },
    SET_ORGANIZATION_ID(state, id) {
      state.organizationId = id
    },
    TOGGLE_LOGGING_OUT(state, value) {
      state.loggingOut = value
    },
    SET_PROJECT_PAGE(state, page) {
      state.projectPage = parseInt(page, 10)
      localStorage.setItem('projectPage', page)
    },
    SET_ERROR_CODE(state, code) {
      state.errorCode = code
    },
    SET_PREVIOUS_ROUTE_NAME(state, value) {
      state.previousRouteName = value
    },
    SET_NAMESPACE(state, namespace) {
      state.namespace = namespace
    },
    SET_DEFAULT_USER(state, value) {
      state.setDefaultUser = value
    },
    SET_EDITOR_THEME(state, value) {
      state.editorLightTheme = value
    },
  },
}
